import type { FC } from 'react';

import { type Control, Controller } from 'react-hook-form';

import type { FilterFormValues } from '@shared/api/findings/filter-form.schema';
import type { FacetedFilter } from '@shared/api/findings/findings.types';
import { getFiltersZeroCount, normalizeOperator } from '@shared/utils/findings/trace-findings.helpers';
import { normalizeFiltersForUI } from '@shared/utils/findings/trace-findings.utils';

import { FilterConditionRow } from './FilterConditionRow';

interface FilterConditionRowsProps {
  selectedFields: string[];
  filtersData: FacetedFilter[];
  filterSearch: string;
  control: Control<FilterFormValues>;
  handleDropdownClose: (fieldKey: string) => void;
  updateFiltersFromForm: () => void;
  toggleField: (field: string) => void;
}
export const FilterConditionRows: FC<FilterConditionRowsProps> = ({
  selectedFields,
  filtersData,
  filterSearch,
  control,
  handleDropdownClose,
  updateFiltersFromForm,
  toggleField,
}) => {
  const sharedRowProps = {
    control,
    onDropdownClose: handleDropdownClose,
    updateFiltersFromForm,
    toggleField,
  };

  return (
    <div data-testid="filter-condition-rows-root">
      {selectedFields.map((fieldKey, index) => {
        const filter = filtersData.find((f) => f.key === fieldKey);
        if (!filter) return null;
        const filterWithTypedKey = {
          ...filter,
          key: filter.key,
          operator: normalizeOperator(filter.operator),
        };

        const mappedFilters = normalizeFiltersForUI(filtersData);
        const filtersZeroCount = getFiltersZeroCount(mappedFilters, filterSearch);
        const isZeroCount = filtersZeroCount.some((f) => f.key === fieldKey);

        return (
          <Controller
            key={fieldKey}
            name={`fieldValues.${fieldKey}.addedWithZeroValues` as const}
            control={control}
            render={({ field }) => (
              <FilterConditionRow
                fieldKey={fieldKey}
                filter={filterWithTypedKey}
                isLastRow={index === selectedFields.length - 1}
                {...sharedRowProps}
                zeroCount={isZeroCount}
                addedWithZeroValues={!!field.value}
              />
            )}
          />
        );
      })}
    </div>
  );
};
